import { Th, OrganizationHeader, OrganizationHeaderLabel } from "./measurementstable.styles";
import { useOrganizationsContext } from "@webapi/contexts/organizations";
import { useUnitListsContext } from "@unitLists";
import { getColorUsingOption } from "utils/colors";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrganizationTableHeader(_ref) {
  var _lookupOrganization, _getColorUsingOption;
  var organizationId = _ref.organizationId,
    query = _ref.query,
    rowIdx = _ref.rowIdx;
  var _useOrganizationsCont = useOrganizationsContext(),
    lookupOrganization = _useOrganizationsCont.lookupOrganization;
  var _useUnitListsContext = useUnitListsContext(),
    activeUnitList = _useUnitListsContext.activeUnitList;
  var name = (_lookupOrganization = lookupOrganization(organizationId)) === null || _lookupOrganization === void 0 ? void 0 : _lookupOrganization.name;
  var organizationIndex = query.units.findIndex(function (x) {
    return x === organizationId;
  });
  var color = (_getColorUsingOption = getColorUsingOption(query.colorSettings, activeUnitList, organizationIndex, organizationId)) === null || _getColorUsingOption === void 0 ? void 0 : _getColorUsingOption.hex;
  return /*#__PURE__*/_jsx(Th, {
    type: "organization",
    scope: "row",
    borderMe: rowIdx === 0,
    "aria-colindex": "1",
    children: /*#__PURE__*/_jsx(OrganizationHeader, {
      color: color,
      title: name,
      children: /*#__PURE__*/_jsx(OrganizationHeaderLabel, {
        children: name
      })
    })
  });
}